/**
 * withCategories
 * HOC for wrapping the provided component with CategoriesProvider
 */

import React from 'react'

import CategoriesProvider from './categories-provider'

export default function withCategories (WrappedComponent) {
  return function CategoriesProviderHOC(props) {
    return (
      <CategoriesProvider {...props}>
        <WrappedComponent {...props} />
      </CategoriesProvider>
    )
  }
}
